import ACTION_TYPES from "../actions/actionTypes";

export default (state, action) => {
  let keys = ["employeeID"];
  switch (action.type) {
    case ACTION_TYPES.GET_RPS_RAIL:
      return { ...state, rpsRail: action.payload };
    case ACTION_TYPES.GET_APPROVER_HIGHEST_TIER:
      return { ...state, approvers: action.payload };
    case ACTION_TYPES.FETCH_PEOPLE:
      return { ...state, peopleList: action.payload };
    case ACTION_TYPES.GET_REASON_CODE_BY_FREQUENCY:
      return { ...state, reasonCodes: action.payload };
    case ACTION_TYPES.FETCH_RPS_GRID:
      return { ...state, rpsGridData: action.payload };
    case ACTION_TYPES.FETCH_RCA_GRID:
      return { ...state, rcaGridData: action.payload };
    case ACTION_TYPES.FETCH_ALL_RPS_DATA:
      return { ...state, rpsAllData: action.payload };
    case ACTION_TYPES.FETCH_TIER_LIST:
      return { ...state, tiersData: action.payload };
    case ACTION_TYPES.GET_OPH_FILE:
      return { ...state, ophFile: action.payload };
    case ACTION_TYPES.GET_SOLUTION_DATA:
      return { ...state, solutionData: action.payload };
    case ACTION_TYPES.GET_PEOPLE_DATA:
      return {
        ...state,
        peopleData: action.payload,
      };
    case ACTION_TYPES.FETCH_PS_DATA:
      return {
        ...state,
        problemSolvingData: action.payload,
        lastSavedTab: action.payload.lastSavedTab,
      };
    case ACTION_TYPES.POST_CONFIRMRESULTS_GRID:
      return { ...state, confirmresultsGridData: action.payload };
    case ACTION_TYPES.FETCH_RCA_ATTACHMENT_DATA:
      return { ...state, rcaAttachmentData: action.payload };
    case ACTION_TYPES.FETCH_CR_DATA:
      return { ...state, rcaConfirmResultData: action.payload };
    case ACTION_TYPES.FETCH_RESULTS_ATTACHMENT_DATA:
      return { ...state, resultsAttachmentData: action.payload };
    case ACTION_TYPES.FETCH_BREAKDOWN_ATTACHMENT_DATA:
      return { ...state, breakdownAttachmentData: action.payload };
    case ACTION_TYPES.FETCH_RAPID_EXPERIMENT:
      return { ...state, rapidExperimentData: action.payload };
    case ACTION_TYPES.FETCH_Experiment_ATTACHMENT:
      return { ...state, experimentAttachmentData: action.payload };
    case "FETCH_PRINT_DATA":
      return { ...state, printInfo: action.payload };
    case "FETCH_SPSWB_DATA":
      return { ...state, spsWbInfo: action.payload };
    case "USER_PREF_SPS":
      return { ...state, userPrefSps: action.payload };
    case ACTION_TYPES.GET_MODULE_DATA:
      return { ...state, moduleData: action.payload };
    case ACTION_TYPES.GET_REASON_CODE_FREQUENCY_BY_MODULE:
      return { ...state, reasonCodeModule: action.payload };
    default:
      return state;
  }
};
